module.exports = "/static/media/image-icon.57fcee75.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/image-icon.png
// module id = 1704
// module chunks = 0